export const ESTADOS_ACADEMICOS = [
  { value: "preinscrito", label: "Preinscrito" },
  { value: "inscrito", label: "Inscrito" },
  { value: "matriculado", label: "Matriculado" },
  { value: "rechazado", label: "Rechazado" },
];

export const estadoLabel = (value) =>
  ESTADOS_ACADEMICOS.find((estado) => estado.value === value)?.label || value || "Sin estado";
